import { render, staticRenderFns } from "./Matrizes.vue?vue&type=template&id=da7a9620&scoped=true&"
import script from "./Matrizes.vue?vue&type=script&lang=js&"
export * from "./Matrizes.vue?vue&type=script&lang=js&"
import style0 from "./Matrizes.vue?vue&type=style&index=0&id=da7a9620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7a9620",
  null
  
)

component.options.__file = "Matrizes.vue"
export default component.exports